<template>
	<div class="main">
		<div class="nav">安全管理>应急预案</div>
		<div class="cont">
			<div class="cont-l">
				<div class="cont-l-title">
					<div>共有文件夹：{{folderList.length}}个</div>
					<div class="addfiles" @click="addEntFun">+</div>
				</div>
				<div class="scroll">
					<div
						v-for="(item,index) in folderList"
						:key="index"
						@click="active(index,item)"
						:class="index_===index?'xuanzhong cont-l-content':'cont-l-content'"
						>
					<div class="l-item">
						<div class="name">
							<i class="el-icon-folder-opened"></i>
							<span class="text">{{item.filesName}}</span>
						</div>
						<div class="btn">
							<div class="btn-l" @click="editFolder(item)">编辑</div>
							<div class="btn-r" @click="delFolder(item)">删除</div>
						</div>
					</div>
				</div>
				</div>
			</div>
			<div class="cont-r">
					<div class="search">
						<el-input v-model="name" style="width:300px" placeholder="请输入类型名称" clearable @change="search">
							<el-button @click="search" slot="append" icon="el-icon-search"></el-button>
						</el-input>
						<el-upload
								class="upload-demo"
								v-if="folderId!=''"
								v-bind:action="uploadUrl"
								:headers="uploadHead"
								:data={type:225}
								:show-file-list="false"
								:on-success="fileSuccess">
								<button class="add" >添加</button>
						</el-upload>
						
        </div>
				<div class="content-i">
					<div class="title">
						<div class="title-item">序号</div>
						<div class="title-item">文件名称</div>
						<div class="title-item">文件大小</div>
						<div class="title-item">上传日期</div>
						<div class="title-item">操作</div>
					</div>
					<div class="scroll-i">
						<div class="row" v-for="(item,index) in tableDataEnd">
							<div class="item row-index">{{index+1}}</div>
							<div class="item row-fileName" @click="showFile(item)">
								<img v-if="item.fileFormat=='0'" src="../../../assets/image/office/undefined.png" style="width:5vh;height:5vh;"  />
									<img v-else-if="item.fileFormat=='1'" src="../../../assets/image/office/word.png" style="width:5vh;height:5vh;" />
									<img v-else-if="item.fileFormat=='2'" src="../../../assets/image/office/excel.png" style="width:5vh;height:5vh;" />
									<img v-else-if="item.fileFormat=='3'" src="../../../assets/image/office/pdf.png" style="width:5vh;height:5vh;" />
									<img v-else-if="item.fileFormat=='4'" src="../../../assets/image/office/photo.png" style="width:5vh;height:5vh;" />
									<img v-else src="../../../assets/image/office/undefined.png" style="width:5vh;height:5vh;" />
									<span style="padding-left:1vw;" class="fileName"
										:title="item.filesName"
									>{{item.filesName}}</span>
							</div>
							<div class="item row-size">{{item.filseCapacity}}B</div>
							<div class="item row-date">{{item.createDate}}</div>
							<div class="item btns">
									<div class="btn-i" @click="handleDown(index, item)">下载</div>
									<div class="btn-i" @click="handleDelete(index, item)">删除</div>
									<div class="btn-i" @click="toPush(item)">一键推送</div>
							</div>
						</div>
					</div>
				</div>
				<div class="fenye">
					<el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageSize"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageNum"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
				</div>
			</div>
		</div>
		<el-dialog
        :title="entTitle"
        :visible.sync="entVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        width="30%"
        >
        <el-form
            :model="addFolder"
            ref="addFolder"
            :rules="rules"
            label-width="200px"
            label-position="right"
            class="joinEnt"
        >
            <el-form-item label="文件名：" prop="fileName">
                <el-input v-model="addFolder.filesName" autocomplete="off" style="width:220px"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="entVisible = false">取 消</el-button>
            <el-button type="primary" @click="sumbitAddFolder('addFolder')">确 定</el-button>
        </div>
        </el-dialog>
				<el-dialog
            :title="codeTit"
            :visible.sync="codeVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
            style="height:100%;"
        >
            <div class="erCode">
                <vue-qr :text="codeUrl" :size="200"></vue-qr>
                <!-- <p style="width:100%;text-align:center;">
                    <el-button type="primary" @click="downCode">确 定</el-button>
                </p> -->
            </div>
        </el-dialog>
	</div>
	
	</div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
import vueQr from 'vue-qr'
export default {
    components: {
            vueQr
    },
    data(){
        return{
            index_:0,
            list:[1,1,1,1,1,1,1,1,1,1,1,1],
            entName:'',//参建单位查询
            groupId:'',
            folderList:[],//参建单位list
            entsTypes:[],//参建单位类型list
            entTitle:'',//参建单位弹出框名称
            entVisible:false,
            persons:[],//参建单位的管理人员
            addFolder:{
                filesType:'1',
                type:'8',
                id: '',
                groupId: '',
                filesName:'',
                userType:''
            },
            rules: {
                filesName: [
                    { required: true, message: '请填写文件名称', trigger: 'blur' }
                ],
            },
            folderId:'',//当前展示文件夹id
            tableDataEnd:[],//班组列表
            diaTitle:'添加文件夹',//班组添加名称
            dataText: '数据加载中...',
            teamName:'',//班组名称
            uploadUrl:base.url+"/upload/uploadPhoto",//上传地址
            uploadHead:{  //上传接口header
                accessToken:this.$store.state.token
            },
            //二维码
            codeVis:false,
            codeUrl:'',
            codeTit:'',
            pageNum: 10,
            pageSize: 1,
            totalItems:0,
            name:''
        }
    },
    mounted(){
        var port = util.session.get('roleId')
        this.groupId = util.session.get('groupId')
        this.getFolder()
        // this.getPerson()
    },
    methods:{
        search(){
            this.getData()
        },
        handleSizeChange(val){
            this.pageNum = val
            this.getData()
        },
        handleCurrentChange(val) {
            
            this.pageSize = val
            this.getData()
        },
				active(index,item){
					this.index_ = index
					this.folderId = item.id
            this.getData()
				},
        //获取文件夹
        getFolder(){
            var that = this
            myHttp.selectFolder({
                filesType:'1',
                type:'8',
                groupId:this.groupId,
                userType:util.session.get('roleId')
            }).then(function(resp){
                if (resp.data.code == '200'){
                    var list = resp.data.data.Files || []
                    if(list.length>0){
                        that.folderId = list.length>0?list[0].id:''
                        that.getData()
                    }else{
                        that.dataText = '暂无数据'
                    }
                    that.folderList = list
                }else{

                }
            })
        },
        //添加参建单位
        addEntFun(){
            this.entVisible = true
            this.addFolder.filesName = ''
            this.addFolder.id = ''
            this.entTitle = '添加文件夹'
        },
        
        //添加或者修改文件夹
        sumbitAddFolder(formName){
            var that = this
            this.addFolder.createBy = util.session.get('user').id
            this.addFolder.groupId = this.groupId
            this.addFolder.userType = util.session.get('roleId')
            this.$refs[formName].validate(valid => {
                if (valid) {
                if (this.addFolder.id == '') {
                    myHttp.addFolderFiles(this.addFolder).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('添加成功')
                        that.entVisible = false
                        that.getFolder()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                } else {
                    myHttp.updateFiles(this.addFolder).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('修改成功')
                        that.entVisible = false
                        that.getFolder()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                }
                } else {
                  return false
                }
            })
        },
        //选择展示的文件夹
        getEntId(row){
            this.folderId = row.id
            this.getData()
        },

        /***
         * 获取文件
         */
        getData(){
            var that = this
            // console.log(this.joinEntId)
            myHttp.selectDocumentNew({
                id:this.folderId,
                pageNum:this.pageNum,
                pageSize:this.pageSize,
                name:this.name
            }).then(function(resp){
                console.log(resp,'99999999999999')
                if (resp.data.code == '200') {
                    that.totalItems = resp.data.data.Files.myList.length
                    var list = resp.data.data.Files.myList || []
                    for(var i=0;i<list.length;i++){
                        list[i].fileFormat = list[i].filesName && list[i].filesName!=''?that.getImg(list[i].filesName):'0'
                    }
                    that.tableDataEnd = list
                    if (that.tableDataEnd.length == 0) {
                        that.dataText = '暂无数据'
                    }
                } else {
                    that.$message.error(resp.data.msg)
                    that.dataText = '暂无数据'
                }
            })
        },
        //获取图片
        getImg(url){
            // 1:word   2:excel    3:pdf     4:img   5:undefined
            var result = '';
            var list = url.split('.')
            var str = list[list.length-1]
            if(base.docType.indexOf(str)>=0){
                result = '1'
            }else if(base.imgType.indexOf(str)>=0){
                result = '4'
            }else if(base.excelType.indexOf(str)>=0){
                result = '2'
            }else if(base.pdfType.indexOf(str)>=0){
                result = '3'
            }else{
                result = '5'
            }
            return result
        },
        /**
         * 根据名称查询班组
         */
        doFilter(){
            this.getTeam()
        },
        /**
         * 添加班组
         */
        // addTeam(){
        //     this.addFormVisible = true
        //     // this.teamPersons = []
        //     this.getPerson()
        //     this.addForm = {
        //         id: '',
        //         name: '',
        //         teamsType: '1',
        //         creditCode: '',
        //         remarks: '',
        //         projectEntId: this.joinEntId,
        //         teamManager: '',
        //         managerTel: ''
        //     }
        //     this.diaTitle = '添加班组'
        // },
        //修改班组
        // handleEdit(index, row) {
        //     this.addFormVisible = true
        //     this.persons = []
        //     this.getPersonByTeam(row.id)
        //     this.addForm.id = row.id
        //     this.addForm.projectEntId = row.projectEntId
        //     this.addForm.name = row.name
        //     this.addForm.teamsType = row.teamsType
        //     this.addForm.creditCode = row.creditCode
        //     this.addForm.entName = row.entName
        //     this.addForm.entId = row.entId
        //     this.addForm.remarks = row.remarks
        //     this.addForm.teamManager = row.teamManager
        //     this.addForm.managerTel = row.managerTel
        //     this.addForm.joinTypeName = row.joinTypeName
        //     this.addForm.deviceSn = row.deviceSn
        //     this.diaTitle = '班组修改'
        // },
        //展示
        showFile(row){
            var that = this
            window.open(base.fileView+'/onlinePreview?url='+encodeURIComponent(base.httpCtx+row.filesAddress),"_blank");
        },
        //下载
        handleDown(index,row){
            window.open(base.httpCtx+row.filesAddress)
        },
        // 删除班组
        handleDelete(index, row) {
            var that = this
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.deleteFiles({
                    id: row.id,
                    updateBy:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message({
                        type: 'success',
                        message: '删除成功!'
                        })
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                })
            }).catch(err => {})
        },
        //上传成功
        fileSuccess(res,file,opt){
            if(res.code==200){
                // console.log(res)
                // console.log(file)
                var obj = {
                    filesType:'2',
                    type:'8',
                    filesName:file.name,
                    filesAddress:res.data.saveUrls,
                    filseCapacity:file.size,
                    groupId:this.groupId,
                    userType:util.session.get('roleId'),
                    parentId:this.folderId,
                    createBy:util.session.get('user').id
                }
                var that = this
                myHttp.addFolderFiles(obj).then(function(resp){
                    if(resp.data.code=='200'){
                        that.$message.success('添加成功')
                        that.getData()
                    }else{
                        that.$message.error(resp.data.msg)
                    }
                })
            }else{
                this.$message.error(res.msg);
            }
            
        },
        //编辑文件夹
        editFolder(obj){
            this.entVisible = true
            this.addFolder.filesName = obj.filesName
            this.addFolder.id = obj.id
            
            this.entTitle = '修改文件夹'

        },
        //删除文件夹
        delFolder(obj){
            
            var that = this
            this.$confirm('此操作将永久删除该文件夹及其中的文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.deleteFiles({
                    id: obj.id,
                    updateBy:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                    that.$message.success('删除成功')
                    that.getFolder()
                    } else {
                    that.$message.error(resp.data.msg)
                    }
                })
            })
        },

        //展示二维码
        erCode(index,row){
            this.codeVis = true
            this.codeUrl = base.httpCtx+row.filesAddress
            this.codeTit = row.filesName
        },
        //一键推送
        toPush(row){
            
        },
    }

}
</script>
<style scoped>
.main{
	background-color: #F5F5F5;
	height: 100%;
	padding-left: 0.5vw;
	padding-right: 1vw;
}
.nav{
	height: 6vh;
	line-height: 6vh;
	display: flex;
	align-items: center;
	font-family: PingFang-SC-Regular;
	font-size: 2vh;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0vh;
	color: #000000;
}
.cont{
	display: flex;
}
.cont-l{
	background-color: #fff;
	width: 15vw;
	height: 82.5vh;
	margin-right: 0.3vw;
	box-shadow: 0px 3px 10px 0px 
		rgba(105, 159, 204, 0.5);
	border-radius: 6px;
	overflow: hidden;
}
.cont-r{
	background-color: #fff;
	width: 73vw;
	height: 82.5vh;
	box-shadow: 0px 3px 10px 0px 
		rgba(105, 159, 204, 0.5);
	border-radius: 6px;
	overflow: hidden;
}
.cont-l-title{
	height: 6vh;
	display: flex;
	justify-content: space-between;
	padding: 0 1vw;
	align-items: center;
	font-family: PingFang-SC-Bold;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.addfiles{
	width: 3.5vh;
	height: 3.5vh;
	line-height: 3vh;
	background-color: #0b62f0;
	border-radius: 6px;
	color: #fff;
	font-size: 30px;
	font-weight:bold;
	cursor: pointer;
}
.btn-i:hover, .add:hover, .btn-l:hover, .btn-r:hover, .addfiles:hover{
    opacity: 0.7;
}
.scroll{
	height: 77vh;
	overflow: scroll;
}
.scroll::-webkit-scrollbar{
	width: 0;
	height: 0;
}
.cont-l-content{
	cursor: pointer;
}
.cont-l-content:hover{
	background-color: #e1edf8;
}
.xuanzhong{
	background-color: #e1edf8;
}
.l-item{
	display: flex;
	padding: 1vw;
	align-items: center;
	justify-content: space-between;
	
}
.name{
	display: flex;
	width: 6.5vw;
	align-items: center;
	justify-content: space-between;
}
.text{
	font-family: PingFang-SC-Bold;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
	flex: 1;
	text-align: left;
	margin-left: 3px;
	overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;
}
.l-item>.btn{
  display: flex;
	justify-content: space-between;
	width: 4.3vw;
}
.btn-l, .btn-r{
	font-family: PingFang-SC-Medium;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #0b62f0;
	cursor: pointer;
}
.btn-r{
	color: #f21707;
}
.search{
	height: 6vh;
	background-color: #fff;
	display: flex;
	justify-content: space-between;
	padding: 0 1vw;
	align-items: center;
}
.add{
  background-color: #0b62f0;
  color: #fff;
  width: 120px;
  height: 4vh;
  font-family: PingFang-SC-Medium;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
  border: none;
  border-radius: 5px;
	cursor: pointer;
}
.content-i{
	height: 71vh;
}
.fenye{
	height: 6vh;
}
.el-pagination{
	background-color: #dfe1e3;
}
.title{
	background-color: #e6e6e6;
	height: 6vh;
	display: flex;
	
}
.title-item{
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	font-family: PingFang-SC-Bold;
	font-size: 22px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 138px;
	letter-spacing: 0px;
	color: #333333;
}
.scroll-i{
	height: 65vh;
	overflow: scroll;
}
.scroll-i::-webkit-scrollbar{
	width: 0;
	height: 0;
}
.row{
	display: flex;
	height: 6vh;
}
.row:hover{
	background-color: #e1edf8;
}
.item{
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
}
.btns{
    display: flex;
}
.btn-i:nth-child(1){
    font-family: PingFang-SC-Medium;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #2e5be9;
	cursor: pointer;
}
.btn-i:nth-child(2){
    font-family: PingFang-SC-Medium;
	font-size: 18px;
	font-weight: normal;
	letter-spacing: 0px;
	color: #f21707;
    margin: 0 12px;
		cursor: pointer;
}
.btn-i:nth-child(3){
  font-family: PingFang-SC-Medium;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #2e5be9;
	cursor: pointer;
}
.row-date{
	font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
}
.row-size{
	font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
}
.row-index{
	font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
}
.fileName{
	font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
	overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;
}
.row-fileName{
	justify-content: start;
	width: 3vw;
	cursor: pointer;
}
</style>
<style>
@import '../../../assets/css/common.css';
</style>